import React, { useEffect, useState } from "react";
import { Empty } from "antd";
import {
  FileDoneOutlined,
  CheckCircleFilled,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import { withTranslation } from "react-i18next";
import axios from "axios";
import url from "../../url.json";
import headers from "../../config/headers";
import { useSearchParams } from "react-router-dom";
import TextEditor from "../TextEditor";
import { isFilled } from "../AddForm1/FormSection";
import "../AddForm1/form.scss";

const langTabs = [
  ["uz", "UZ", "Uzbek"],
  ["ru", "RU", "Russian"],
  ["en", "EN", "English"],
];
const sections = ["general", "pharmacological", "usage", "prevention"];

function ShowInstruction({ t }) {
  const [searchParams] = useSearchParams();
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const [instruction, setInstruction] = useState();
  const [lang, setLang] = useState("uz");

  useEffect(() => {
    axios
      .get(url.url + `/application/${searchParams.get("id")}`, {
        headers: headers(),
      })
      .then((res) => {
        setInstruction(res.data.data.drug.instruction || {});
      })
      .catch(() => {});
  }, []);

  const filledIn = (l) =>
    sections.filter((name) => isFilled(instruction?.[name]?.[l])).length;

  return (
    <section className="af-card ins-card ins-read">
      <div className="af-card__head">
        <div className="af-card__title">
          <span className="af-card__num">
            <FileDoneOutlined />
          </span>
          <h5>{t("Instruction")}</h5>
        </div>
        <div className="ins-langs">
          {langTabs.map(([key, short, label]) => (
            <button
              type="button"
              key={key}
              title={t(label)}
              className={lang === key ? "ins-lang ins-lang--active" : "ins-lang"}
              onClick={() => setLang(key)}
            >
              {short}
              {filledIn(key) === sections.length ? (
                <CheckCircleFilled className="ins-lang__done" />
              ) : (
                <ExclamationCircleFilled className="ins-lang__todo" />
              )}
            </button>
          ))}
        </div>
      </div>

      {!instruction ? (
        <Empty description={t("Loading...")} />
      ) : (
        <div className="ins-read__list">
          {sections.map((name, i) => {
            const value = instruction?.[name]?.[lang];
            return (
              <div className="ins-read__item" key={name}>
                <div className="ins-read__head">
                  <span
                    className={
                      isFilled(value)
                        ? "ins-read__num"
                        : "ins-read__num ins-read__num--empty"
                    }
                  >
                    {i + 1}
                  </span>
                  <h6>{t(name)}</h6>
                </div>
                {isFilled(value) ? (
                  <div className="ins-read__body">
                    <TextEditor
                      key={`${lang}-${name}`}
                      id={lang}
                      disabled={true}
                      value={value}
                    />
                  </div>
                ) : (
                  <div className="ins-read__empty">
                    <ExclamationCircleFilled />
                    {t("No data")}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
export default withTranslation()(ShowInstruction);
